<template>
  <div ref="download"></div>
</template>
<script>
import OpenApp from '@/common/openApp';

const openApp = new OpenApp();
const SCHEME = 'shopshopsng://shopshops.top:8080/openOfH5';
export default {
  name: 'Download',
  data() {
    return {
      url: SCHEME,
    };
  },
  mounted() {
    this.toOpenApp();
    // 是否开启自动跳转下载
    if (true) {
      this.toDownload();
    }
  },
  methods: {
    toOpenApp() {
      openApp.init(this.openParam);
      this.$store.commit('SET_OVERLAY', true);
    },
    toDownload() {
      openApp.download();
    },
  },
};
</script>
